import React, { Component } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import Header from "../header";
import Footer from "../footer";
import Home from "../web/views/home";
import Category from "./views/category";
import Singleproduct from "./views/single-product";
import PrivateRoute from "../PrivateRoute";
import Checkout from "./views/checkout";
import Login from "./views/checkout/login";
import Register from "./views/checkout/register";
import NotFound from "../../NotFound";
import Account from "./views/account";
import Failed from "./views/checkout/failed";
import AboutUs from "../pages/aboutus"
import ContactUs from "../pages/contactus";
import Sitemap from "../pages/sitemap";
import PrivacyPolicy from "../pages/privacypolicy";
import TermsAndConditions from "../pages/termsandconditions";
import Wishlist from "./views/account/wishlist";
import Pricing from "../pages/pricing";
import ReturnsAndCancellation from "../pages/returnsandcancelations";
import tagproduct from "./views/tagproduct";
import Search from "./views/home/search";
import Success from "./views/checkout/success";
import WalletFailed from "./views/account/wallet/failed";
import Embroidery from "./views/embroideryviewer";


// Function to check and authenticate from query parameters
const authenticateFromQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const email = urlParams.get("email");

  if (token && email) {
    // Store token and email in sessionStorage
    sessionStorage.setItem("_sid", token);
    sessionStorage.setItem("email", email);

    // Clear the query parameters from the URL (update history without reloading the page)
    const cleanUrl = window.location.pathname;
    window.history.replaceState(null, "", cleanUrl); // Removes the query params
  }
};

class RootRoutes extends Component {
  constructor(props) {
    super(props);
    // Check and authenticate from query parameters immediately
    authenticateFromQueryParams();
  }

  render() {
    const { location } = this.props;
    const shouldShowSearch = !(
      location.pathname === "/" ||
      location.pathname.startsWith("/account") ||
      location.pathname.startsWith("/tagsearch") ||
      location.pathname.startsWith("/embroidery")
    );

    return (
      <div>
        <Header />
        {shouldShowSearch && <Search />}{" "}
        {/* Render Search only if not on Home */}
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/p/:hash" component={Singleproduct} />
          <Route exact path="/tagsearch/:tag" component={tagproduct} />
          <PrivateRoute path="/checkout" component={Checkout} />
          {/* <Route path="/stitchviewer" component={EmbroideryViewer} /> */}
          <Route path="/embroidery" component={Embroidery} />
          <Route path="/category" component={Category} />
          <PrivateRoute path="/order/failed" component={Failed} />
          <PrivateRoute path="/wallet/failed" component={WalletFailed} />
          <PrivateRoute path="/order/success" component={Success} />
          <Route exact path="/wishlist" component={Wishlist} />
          <PrivateRoute path="/account" component={Account} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/about-us" component={AboutUs} />
          <Route exact path="/contact-us" component={ContactUs} />
          <Route exact path="/sitemap" component={Sitemap} />{" "}
          {/* Add this line */}
          <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/pricing" component={Pricing} />
          <Route
            path="/returnsandcancellation"
            component={ReturnsAndCancellation}
          />
          <Route
            exact
            path="/terms-and-conditions"
            component={TermsAndConditions}
          />
       
          {/* Dynamic Route for Category or Subcategory */}
          <Route
            path="/products"
            render={(props) => {
              const queryParams = new URLSearchParams(props.location.search);
              const categoryId = queryParams.get("categoryId");
              const subcategoryId = queryParams.get("subcategoryId");
              return (
                <Category
                  categoryId={categoryId}
                  subcategoryId={subcategoryId}
                  {...props}
                />
              );
            }}
          />
          {/* Catch-all Route for 404 */}
             <Route component={NotFound} />
          <Route path="*" component={() => <div>404 Not Found</div>} />
        </Switch>
        <Footer />
      </div>
    );
  }
}

// Export the component wrapped with withRouter to get access to location
export default withRouter(RootRoutes);
